.accordionRoot {
  display: var(--haus-checkout__accordionRoot__display, flex);
  flex-direction: var(--haus-checkout__accordionRoot__flex-direction, column);
  gap: var(--haus-checkout__accordionRoot__gap, 0);
  width: var(--haus-checkout__accordionRoot__width, 100%);
  border: var(--haus-checkout__accordionRoot__border, none);
  border-radius: var(--haus-checkout__accordionRoot__border-radius, 0);
}

.accordionItem {
  border-bottom: var(--haus-checkout__accordionItem__border-bottom, 1px solid rgba(0, 0, 0, 0.1));

  &:last-child {
    border-bottom: var(--haus-checkout__accordionItem__last-child__border-bottom, none);
  }

  &[data-disabled] {
    opacity: var(--haus-checkout__accordionItem__disabled__opacity, 0.5);
  }
}

.accordionHeader {
  margin: var(--haus-checkout__accordionHeader__margin, 0);
}

.accordionTrigger {
  width: var(--haus-checkout__accordionTrigger__width, 100%);
  display: var(--haus-checkout__accordionTrigger__display, flex);
  align-items: var(--haus-checkout__accordionTrigger__align-items, center);
  justify-content: var(--haus-checkout__accordionTrigger__justify-content, space-between);
  gap: var(--haus-checkout__accordionTrigger__gap, 8px);
  padding: var(--haus-checkout__accordionTrigger__padding, 16px 0);
  border: var(--haus-checkout__accordionTrigger__border, none);
  border-radius: var(--haus-checkout__accordionTrigger__border-radius, 0);
  background: var(--haus-checkout__accordionTrigger__background, transparent);
  color: var(--haus-checkout__accordionTrigger__color, var(--haus-color-text, #000));
  font-family: var(
    --haus-checkout__accordionTrigger__font-family,
    var(--haus-typography-body-font-family, 'Inter, sans-serif')
  );
  font-size: var(--haus-checkout__accordionTrigger__font-size, 1.125rem);
  font-weight: var(--haus-checkout__accordionTrigger__font-weight, 600);
  text-align: var(--haus-checkout__accordionTrigger__text-align, start);
  cursor: var(--haus-checkout__accordionTrigger__cursor, pointer);

  &:hover:not([data-disabled]) {
    color: var(--haus-checkout__accordionTrigger__hover__color, var(--haus-color-primary, #000));
  }

  &[data-disabled] {
    cursor: var(--haus-checkout__accordionTrigger__disabled__cursor, not-allowed);
  }
}

.accordionChevron {
  flex-shrink: var(--haus-checkout__accordionChevron__flex-shrink, 0);
  transition: var(--haus-checkout__accordionChevron__transition, transform 200ms ease);
}

.accordionTrigger[data-state='open'] .accordionChevron {
  transform: var(--haus-checkout__accordionChevron__open__transform, rotate(180deg));
}

.accordionContent {
  overflow: var(--haus-checkout__accordionContent__overflow, hidden);
  padding-bottom: var(--haus-checkout__accordionContent__padding-bottom, 16px);

  &[data-state='open'] {
    animation: var(
      --haus-checkout__accordionContent__open__animation,
      checkoutAccordionSlideDown 200ms ease-out
    );
  }

  &[data-state='closed'] {
    animation: var(
      --haus-checkout__accordionContent__closed__animation,
      checkoutAccordionSlideUp 200ms ease-in
    );
  }
}

@keyframes checkoutAccordionSlideDown {
  from {
    height: var(--haus-checkout__accordionContent__closed__height, 0);
  }
  to {
    height: var(--radix-accordion-content-height);
  }
}

@keyframes checkoutAccordionSlideUp {
  from {
    height: var(--radix-accordion-content-height);
  }
  to {
    height: var(--haus-checkout__accordionContent__closed__height, 0);
  }
}

@media (prefers-reduced-motion: reduce) {
  .accordionChevron {
    transition: var(--haus-checkout__accordionChevron__reduced-motion__transition, none);
  }

  .accordionContent {
    &[data-state='open'],
    &[data-state='closed'] {
      animation: var(--haus-checkout__accordionContent__reduced-motion__animation, none);
    }
  }
}
